/**
 * Patients Layout Route
 * Layout route that provides structure for patients list and detail pages
 * Renders an Outlet for child routes (index, $patientId, new)
 */

import { createFileRoute, Outlet } from "@tanstack/react-router";

/**
 * Patients Layout Component
 * Simply renders an Outlet for child routes
 */
const PatientsLayoutComponent = () => {
  return <Outlet />;
};

/**
 * Route Configuration
 * Path: /_authenticated/patients
 * - Layout route (no direct content, just Outlet for children)
 * - Children: index (list), $patientId (detail), new (create)
 */
export const Route = createFileRoute("/_authenticated/patients")({
  component: PatientsLayoutComponent,
});
